<template>
	<v-sheet color="transparent">
		<h2 class="cn-font grey--text">Zusammenarbeitsvorgänge</h2>
		<p class="mt-2">Das CheckIT-Now Tool stellt Ihnen verschiedene Möglichkeiten zur Verfügung, um Ihre Erhebung gemeinsam mit Anderen zu bearbeiten. Auf dieser Seite erhalten Sie einen Überblick über Ihre Zusammenarbeitsvorgänge.</p>
		<v-row>
			<v-col cols="12" md="7">
				<v-list v-for="collab in collaborations" :key="collab.id" class="mt-2 elevation-3">
					<CollaborationListItem :id="collab.id"></CollaborationListItem>
				</v-list>
			<v-card-actions class="mt-4"> 
				<BackButton></BackButton>
				<v-spacer></v-spacer>
					<v-dialog width="500" v-model="new_dialog">
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" rounded color="primary">Neuen Zusammenarbeitsvorgang Anlegen</v-btn>
						</template>
						<v-card>
							<DialogTitle @close="new_dialog = false" title="Neuen Zusammenarbeitsvorgang Anlegen"></DialogTitle>
							<NewCollaboration></NewCollaboration>
						</v-card>
					</v-dialog>
			</v-card-actions>
			</v-col>
			<v-col cols="12" md="5">
				<v-row>	
					<v-col>
						<Tile title="Ihre Tools" :editable="false" width="100%" class="mb-4">
							<template v-slot:content>
								<CollaborationTypes></CollaborationTypes>

							</template>
						</Tile>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-sheet>
</template>
<script>
	import Vuex from "vuex";
	import Tile from "@/components/elements/Tile"
	import BackButton from "@/components/elements/BackButton"
	import DialogTitle from "@/components/elements/DialogTitle"
	import CollaborationTypes from "@/components/assessment/content/CollaborationTypes"
	import CollaborationListItem from "@/components/assessment/collaborations/CollaborationListItem"
	import NewCollaboration from "@/components/assessment/collaborations/NewCollaboration"
	// import Group from "@/components/assessment/Group.vue"
	export default {
		name: "Collaborations",
		components: {
			Tile, 
			BackButton,
			DialogTitle,
			CollaborationListItem,
			CollaborationTypes,
			NewCollaboration,
		}, 
		data: () => {
			return {
				new_dialog: false
			}
		},
		computed: {
			...Vuex.mapState({
				collaborations: state => state.collaborations
			}),
		},
		methods: {
		}
	}
</script>